import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import type { Options, UseQueryOptionsNoKeyAndFn } from "../_types";
import { VEHICLE_BUY_IN_RESOURCE } from "./use-vehicle-buy-in-create-data.query";

export const VEHICLE_BUY_IN_BY_UUID_API_PATH = "/v1/vehicle-buy-in/{uuid}" as const;

export type VehicleBuyInByUuidParameters = paths[typeof VEHICLE_BUY_IN_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type VehicleBuyInByUuidResponse =
  paths[typeof VEHICLE_BUY_IN_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useVehicleBuyInByUuidQuery(
  uuid: string,
  options?: Options<VehicleBuyInByUuidParameters, never>,
  queryOptions?: UseQueryOptionsNoKeyAndFn<
    VehicleBuyInByUuidResponse,
    Error,
    VehicleBuyInByUuidResponse,
    readonly unknown[]
  >,
) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<VehicleBuyInByUuidParameters, never>>(options);
  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    queryKey: [VEHICLE_BUY_IN_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const apiPath = VEHICLE_BUY_IN_BY_UUID_API_PATH.replace("{uuid}", uuid);
      const response = await alphartisApiAxios.get<VehicleBuyInByUuidResponse>(apiPath, {
        params: requestParameters,
      });

      return response.data;
    },
    ...queryOptions,
    enabled: Boolean(uuid) && (queryOptions?.enabled ?? true),
  });
}
